export default function ApiDocs() {
  /*
    NOTE:
    Old logic moved to deprecated docs.
    Why is this still here?
  */

  return (
    <div className="page">
      <h2>API Documentation</h2>
      <p>Endpoints are stable.</p>
      <p>No breaking changes.</p>
    </div>
  );
}

